import React, { useState } from 'react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { inventoryApi } from './inventoryApi';

const UNITS = ['pz', 'kg', 'g', 'lt', 'ml', 'porción'];

export const SupplyFormDialog = ({ supply, onClose, onSaved }) => {
  const isNew = !supply.id;
  const [form, setForm] = useState({
    name: supply.name || '',
    unit: supply.unit || 'pz',
    stock: '',
    min_stock: supply.min_stock ?? '',
    cost_per_unit: supply.cost_per_unit ?? '',
  });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async () => {
    if (!form.name.trim()) return toast.error('Ingresa el nombre del insumo');
    setSaving(true);
    try {
      const body = {
        name: form.name.trim(),
        unit: form.unit,
        min_stock: Number(form.min_stock) || 0,
        cost_per_unit: Number(form.cost_per_unit) || 0,
      };
      if (isNew) await inventoryApi.createItem({ ...body, stock: Number(form.stock) || 0 });
      else await inventoryApi.updateItem(supply.id, body);
      toast.success(isNew ? 'Insumo creado' : 'Insumo actualizado');
      onSaved();
      onClose();
    } catch (e) {
      toast.error(e.message);
    } finally {
      setSaving(false);
    }
  };

  const field = 'mt-1 bg-black/50 border-gray-700 text-white';
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-gray-900 border-gray-700 text-white" data-testid="supply-form-dialog">
        <DialogHeader><DialogTitle>{isNew ? 'Nuevo insumo' : 'Editar insumo'}</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <div className="col-span-2">
            <Label className="text-gray-300">Nombre</Label>
            <Input value={form.name} onChange={set('name')} placeholder="Ej. Pieza de pollo, Coca-Cola 600ml" className={field} data-testid="supply-form-name" />
          </div>
          <div>
            <Label className="text-gray-300">Unidad</Label>
            <select value={form.unit} onChange={set('unit')} className="mt-1 w-full h-10 rounded-md border border-gray-700 bg-gray-950 text-white px-3 [color-scheme:dark]" data-testid="supply-form-unit">
              {UNITS.map((u) => <option key={u} value={u}>{u}</option>)}
            </select>
          </div>
          {isNew && (
            <div>
              <Label className="text-gray-300">Existencia inicial</Label>
              <Input type="number" step="any" value={form.stock} onChange={set('stock')} placeholder="0" className={field} data-testid="supply-form-stock" />
            </div>
          )}
          <div>
            <Label className="text-gray-300">Stock mínimo (alerta)</Label>
            <Input type="number" step="any" value={form.min_stock} onChange={set('min_stock')} placeholder="0" className={field} data-testid="supply-form-min" />
          </div>
          <div>
            <Label className="text-gray-300">Costo por unidad ($)</Label>
            <Input type="number" step="any" value={form.cost_per_unit} onChange={set('cost_per_unit')} placeholder="0.00" className={field} data-testid="supply-form-cost" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} className="border-gray-600 text-gray-300">Cancelar</Button>
          <Button onClick={save} disabled={saving} className="bg-emerald-600 hover:bg-emerald-700" data-testid="supply-form-save">{saving ? 'Guardando...' : 'Guardar'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
